export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResetPassword.vue?vue&type=template&id=184a8a30&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/recover/ResetPassword.vue?vue&type=template&id=184a8a30&scoped=true&
// module id = 1516
// module chunks = 0